module.exports = __webpack_public_path__ + "img/316.f865dcff.png";